import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {DateiSystemService} from '../../provider/datei-system/datei-system.service';
import {UserService} from '../../provider/user/user.service';
import {ErrorHandlingService} from '../../provider/error-handling/error-handling.service';
import {NATIVES_TXT, TOAST_TXT} from '../../strings/language';
import {Router} from '@angular/router';
import {APP_ROUTES} from '../../../environments/environment';
import {Capacitor} from '@capacitor/core';
import {AvailableResult, NativeBiometric} from 'capacitor-native-biometric';

@Component({
	selector: 'app-regisafe-offline-login',
	templateUrl: './regisafe-offline-login.component.html',
	styleUrls: ['./regisafe-offline-login.component.scss'],
})
export class RegisafeOfflineLoginComponent implements OnInit, OnChanges {

	@Input() data: any;
	@Input() invalid: boolean;
	@Input() biometricAvailableInParent: boolean;
	@Input() configurationInParent: any;
	public userData: any = {
		username: '',
		password: ''
	};

	constructor(private dateiService: DateiSystemService,
				private userService: UserService,
				private router: Router,
				private errorHandling: ErrorHandlingService) {
	}

	async ngOnInit() {
		this.userData = this.data;
	}

	ngOnChanges(changes: SimpleChanges) {
		if (changes.hasOwnProperty('data')) {
			this.userData = changes.data.currentValue;
		}
		if (changes.hasOwnProperty('invalid')) {
			this.invalid = changes.invalid.currentValue;
		}
	}

	async offlineLogin() {
		if (!this.biometricAvailableInParent) {
			const password = this.userData.password;
			const storedHash = await this.dateiService.leseDateiHash();
			const inputHash = await this.userService.makeHashFromPassword(password);

			if ((storedHash.data === inputHash)) {
				this.router.navigate([APP_ROUTES.inbearbeitung]);
			} else {
				this.errorHandling.errorMessage(TOAST_TXT.message.str00050, 'toast', false);
			}
		} else {
			this.biometricLogin();
		}
	}

	biometricLogin() {
		if (Capacitor.getPlatform() !== 'web') {
			NativeBiometric.isAvailable()
				.then((result: AvailableResult) => {
					if (result.isAvailable) {
						NativeBiometric.getCredentials({
							server: this.configurationInParent.iqapiDomain
						}).then(async (credentials) => {
							NativeBiometric.verifyIdentity({
								reason: NATIVES_TXT.biometric.reason,
								title: NATIVES_TXT.biometric.title,
								subtitle: NATIVES_TXT.biometric.subtitle,
								description: NATIVES_TXT.biometric.description
							}).then(async () => {
								const password = credentials.password;
								const storedHash = await this.dateiService.leseDateiHash();
								const credentialHash = await this.userService.makeHashFromPassword(password);
								//const inputHash = await this.userService.makeHashFromPassword(this.userData.password);
								//if (storedHash.data === credentialHash && credentialHash === inputHash) {
								if (storedHash.data === credentialHash) {
									this.router.navigate([APP_ROUTES.inbearbeitung]);
								} else {
									this.errorHandling.errorMessage(TOAST_TXT.message.str00050, 'toast', false);
								}

							}).catch((e) => {
								this.errorHandling.errorMessage(TOAST_TXT.message.str00060, 'toast');
							});

						}).catch((error) => {
							this.errorHandling.errorMessage(TOAST_TXT.message.str00070, 'toast');
						});
					}
				});
		}
	}

}
